<template>
  <div>
    <h2>出错啦</h2>
  </div>
</template>
<script>
export default {
  created() {
    this.$router.push('/')
  },
}
</script>
